import {
  Wrench, Zap, Droplets, Hammer, Thermometer, Paintbrush, Search, Home,
  Clock, PiggyBank, ShieldCheck, Shield, Lock, Award, Headphones,
} from "lucide-react";

export const COMPANY = {
  name: "Napolano Impianti S.r.l.",
  shortName: "Napolano",
  brandName: "NAPOLANO IMPIANTI",
  tagline: "CI PENSIAMO NOI!",
  productName: "Formula Senza Pensieri",
  address: "Cancello ed Arnone (CE) 81030",
  phone: "0823 45263160",
  email: "napolano.impiantisrl@gmail.com",
  piva: "04319510618",
  rea: "REA 317032",
  area: "Cancello ed Arnone e tutta la provincia di Caserta",
  servicesSummary: "impianti elettrici, idraulici e manutenzioni in generale",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home", testid: "nav-link-home" },
  { label: "Come Funziona", href: "#come-funziona", testid: "nav-link-come-funziona" },
  { label: "Pacchetti di Manutenzione", href: "#pacchetti", testid: "nav-link-pacchetti" },
];

export const MARQUEE_ITEMS = [
  "Impianti elettrici",
  "Interventi idraulici",
  "Manutenzione generale",
  "Formula Senza Pensieri",
  "Cancello ed Arnone — Caserta",
  "Tecnici qualificati",
  "Nessun vincolo",
];

export const BENEFITS = [
  {
    icon: Clock,
    title: "Comodo e senza pensieri",
    text: "Niente più ricerche last-minute di un tecnico. Prenoti i tuoi interventi quando vuoi, con una telefonata o un messaggio. Al resto pensiamo noi.",
  },
  {
    icon: PiggyBank,
    title: "Più conveniente",
    text: "Un canone mensile fisso invece di chiamate singole a caro prezzo. Sai sempre quanto spendi, senza sorprese in bolletta.",
  },
  {
    icon: ShieldCheck,
    title: "Professionisti di fiducia",
    text: "Sempre lo stesso team qualificato, che conosce casa e ufficio tuoi. Persone competenti su cui puoi contare, ogni volta.",
  },
];

export const STEPS = [
  { number: 1, title: "Scegli il pacchetto", text: "Base, Plus o Premium, in base a quanto ti serve." },
  { number: 2, title: "Attivi l'abbonamento", text: "Pagamento sicuro, nessun vincolo. Disdici quando vuoi." },
  { number: 3, title: "Ci pensa Napolano", text: "Prenoti gli interventi e noi arriviamo puntuali." },
];

export const SERVICES = [
  { icon: Wrench, label: "Piccole riparazioni", text: "Guasti e piccoli problemi risolti in fretta." },
  { icon: Zap, label: "Impianti elettrici", text: "Controlli, prese, interruttori e messa a norma." },
  { icon: Droplets, label: "Interventi idraulici", text: "Perdite, rubinetti, scarichi e sanitari." },
  { icon: Hammer, label: "Montaggio mobili", text: "Mobili, mensole, tende e accessori." },
  { icon: Thermometer, label: "Manutenzione climatizzatori", text: "Pulizia filtri e controllo prima dell'estate." },
  { icon: Paintbrush, label: "Ritocchi e piccole opere", text: "Pittura, stuccature e finiture." },
  { icon: Search, label: "Controlli periodici", text: "Verifiche programmate per prevenire i guasti." },
  { icon: Home, label: "Check-up stagionali", text: "Casa pronta in ogni stagione dell'anno." },
];

export const PLANS = [
  {
    id: "base",
    name: "Base",
    price: "7,99",
    paymentLink: "https://buy.stripe.com/bJecN764a7ze0ZW19mdZ600",
    description: "La manutenzione essenziale per la tua casa.",
    features: [
      "2 interventi all'anno inclusi",
      "Check-up annuale della casa",
      "Assistenza telefonica dedicata",
      "Sconto 10% su interventi extra",
    ],
    highlighted: false,
    testid: "plan-card-base",
    ctaTestid: "plan-cta-base",
  },
  {
    id: "plus",
    name: "Plus",
    price: "14,99",
    paymentLink: "https://buy.stripe.com/00w4gBakq4n2eQMdW8dZ601",
    description: "Il giusto equilibrio tra servizi e convenienza.",
    features: [
      "4 interventi all'anno inclusi",
      "2 check-up stagionali",
      "Assistenza prioritaria",
      "Manutenzione climatizzatori inclusa",
      "Sconto 15% su interventi extra",
    ],
    highlighted: true,
    badge: "Più scelto",
    testid: "plan-card-plus",
    ctaTestid: "plan-cta-plus",
  },
  {
    id: "premium",
    name: "Premium",
    price: "19,99",
    paymentLink: "https://buy.stripe.com/dRmaEZ78eg5K3848BOdZ602",
    description: "Massima tranquillità, assistenza prioritaria.",
    features: [
      "Interventi illimitati (piccole riparazioni)",
      "Check-up stagionali inclusi",
      "Assistenza prioritaria entro 24h",
      "Tecnico dedicato di fiducia",
      "Sconto 20% su ricambi e materiali",
    ],
    highlighted: false,
    testid: "plan-card-premium",
    ctaTestid: "plan-cta-premium",
  },
];

export const GUARANTEES = [
  { icon: Shield, title: "Nessun vincolo", text: "Disdici quando vuoi, senza penali." },
  { icon: Lock, title: "Pagamenti sicuri", text: "Transazioni protette tramite Stripe." },
  { icon: Award, title: "Tecnici qualificati", text: "Professionisti esperti e affidabili." },
  { icon: Headphones, title: "Sempre disponibili", text: "Prenoti gli interventi quando serve a te." },
];

export const HERO_IMAGE = "https://images.unsplash.com/photo-1649768870222-17848797d6b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxmcmllbmRseSUyMGhhbmR5bWFuJTIwdGVjaG5pY2lhbiUyMHNtaWxpbmclMjB0b29scyUyMHVuaWZvcm0lMjBwb3J0cmFpdHxlbnwwfHx8fDE3OTA2MTA2NjJ8MA&ixlib=rb-4.1.0&q=85";
